import { oz } from '@weft/utils';
import { withNullAsOptional } from '../../utils/literal-transforms';

export const NewBankDetailsSchema = oz.object({
  bankName: withNullAsOptional(oz.string()),
  routingNumber: withNullAsOptional(oz.string().length(9)),
  accountNumber: withNullAsOptional(oz.string().max(12)),
}).openapi('NewBankDetails');

export type NewBankDetails = oz.infer<typeof NewBankDetailsSchema>;